export default function Dashboard() {
    return (
        <div>Home</div>
    );
}